import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'src/app/core/directives/directives.module';
import { NoRecordsPlaceholderComponent } from 'src/app/extensions/components/no-records-placeholder/no-records-placeholder.component';
import { AddUserPlaceholderComponent } from 'src/app/extensions/components/svg-custom-placeholders/add-user-placeholder/add-user-placeholder.component';
import { RequestSentPlaceholderComponent } from 'src/app/extensions/components/svg-custom-placeholders/request-sent-placeholder/request-sent-placeholder.component';
import { DynamicFieldComponent } from './dynamic-field/dynamic-field.component';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { LanguagePopupComponent } from './language-popup/language-popup.component';
import { PopupComponent } from './popup/popup.component';
import { CountBadgeBodyComponent } from './count-badge-body/count-badge-body.component';
import { InfoPopupComponent } from './info-popup/info-popup.component';
import { UserBadgeComponent } from './user-badge/user-badge.component';
import { CssFilePopupComponent } from './css-file-popup/css-file-popup.component';
import { DetailsListModalComponent } from './details-list-modal/details-list-modal.component';
import { ImageCaptureModalComponent } from './image-capture-modal/image-capture-modal.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DeleteItemModalComponent } from './delete-item-modal/delete-item-modal.component';
import { SpecialOfferPopupComponent } from './special-offer-popup/special-offer-popup.component';
import { BannerNotificationComponent } from './banner-notification/banner-notification.component';
import { MapModalComponent } from './map-modal/map-modal.component';

@NgModule({
  declarations: [
    NoRecordsPlaceholderComponent,
    AddUserPlaceholderComponent,
    RequestSentPlaceholderComponent,
    DynamicFieldComponent,
    LanguagePopupComponent,
    PopupComponent,
    DynamicTableComponent,
    CountBadgeBodyComponent,
    InfoPopupComponent,
    UserBadgeComponent,
    CssFilePopupComponent,
    DetailsListModalComponent,
    ImageCaptureModalComponent,
    DeleteItemModalComponent,
    SpecialOfferPopupComponent,
    BannerNotificationComponent,
    MapModalComponent,
  ],
  imports: [CommonModule, TranslateModule.forChild(), DropDownsModule],
  exports: [
    DirectivesModule,
    NoRecordsPlaceholderComponent,
    AddUserPlaceholderComponent,
    RequestSentPlaceholderComponent,
    DynamicFieldComponent,
    LanguagePopupComponent,
    PopupComponent,
    DynamicTableComponent,
    UserBadgeComponent,
    DeleteItemModalComponent,
    BannerNotificationComponent,
  ],
})
export class ComponentsModule {}
